import { StoreState } from '@/redux/types';
import { getCore } from './getCore';

export const getFonts = (state: StoreState) => getCore(state).fonts;
